









































































































import { Vue, Prop, Component } from "vue-property-decorator";
import AButton from "./private/AButton.vue";
import { PickType } from "./private/Utils";
import ID from "../../ID";

@Component({
    components: {
        AButton,
    },
})
export default class AbcTimePicker extends Vue {
    @Prop() value!: Date | null;
    @Prop({ default: null }) label!: string | null;
    @Prop({ default: null }) error!: string | boolean | null;
    @Prop({ type: Boolean }) isEmbedded!: boolean;

    id = ID.next();

    picking: PickType = "t";

    private get ref(): Date {
        return this.value || new Date();
    }

    private get hours() {
        return this.ref.getHours();
    }

    private set hours(h: number) {
        this.$emit("input", new Date(this.ref.getFullYear(), this.ref.getMonth(), this.ref.getDate(), h, this.minutes));
        this.picking = "t";
    }

    private get minutes() {
        return this.ref.getMinutes();
    }

    private set minutes(m: number) {
        this.$emit("input", new Date(this.ref.getFullYear(), this.ref.getMonth(), this.ref.getDate(), this.hours, m));
        this.picking = "t";
    }
}
